import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Divider, useTheme } from "@mui/material";
import { applyTokens } from "../../../utilities/applyTokens.js";
function AtlasDivider(_a) {
    var { color = "default", dividerStyle = "solid" } = _a, props = __rest(_a, ["color", "dividerStyle"]);
    const { tokens: { component: { divider }, }, } = useTheme();
    const borderColor = color === "default"
        ? divider.colors.default.borderColor.value
        : divider.colors.secondary.borderColor.value;
    const dashPlusSpace = `calc(${divider.styles.dashed.dash.value} + ${divider.styles.dashed.space.value})`;
    const generateBackground = (direction) => `linear-gradient(to ${direction}, ${borderColor} ${divider.styles.dashed.space.value}, transparent ${divider.styles.dashed.space.value}) ${dashPlusSpace} repeat-${direction === "right" ? "x" : "y"}`;
    const dashedStyles = {
        border: "none",
        height: divider.styles.dashed.borderWidth.value,
        background: generateBackground("right"),
        backgroundPosition: "0 0",
        backgroundSize: `${dashPlusSpace} ${divider.styles.dashed.borderWidth.value}`,
        "&.MuiDivider-vertical": {
            border: "none",
            width: divider.styles.dashed.borderWidth.value,
            height: "100%",
            background: generateBackground("bottom"),
            backgroundPosition: "0 0",
            backgroundSize: `${divider.styles.dashed.borderWidth.value} ${dashPlusSpace}`,
        },
    };
    const dividerStyles = Object.assign(Object.assign({}, (dividerStyle === "dashed" ? dashedStyles : {})), (color === "secondary" ? applyTokens(divider.colors.secondary) : {}));
    return _jsx(Divider, Object.assign({ sx: dividerStyles }, props));
}
export const DividerPresets = () => {
    return {
        components: {
            Divider: AtlasDivider,
        },
    };
};
//# sourceMappingURL=divider.js.map